module.exports = __webpack_public_path__ + "static/media/influence_targaryen_3stars.076490ab.png";